import store from '../store';
import Constants from '../config/constants';
import {serviceCreateContact, serviceGetContact, serviceUpdateContact,serviceDeleteContact, serviceCreateCustomer, serviceGetCustomer, serviceCreateQuery} from "../services/Contact.service";
import EventEmitter from "../libs/Events.utils";


export const FETCH_INIT = 'FETCH_INIT_CONTACT';
export const FETCHED = 'FETCHED_CONTACT';
export const FETCHED_FAIL = 'FETCHED_FAIL_CONTACT';
export const FETCHED_FILTER = 'FETCHED_FILTER_CONTACT';
export const FETCH_NEXT = 'FETCH_NEXT_CONTACT';
export const FILTER = 'FILTER_CONTACT';
export const RESET_FILTER = 'RESET_FILTER_CONTACT';
export const SET_SORTING = 'SET_SORTING_CONTACT';
export const SET_FILTER = 'SET_FILTER_CONTACT';
export const SET_PAGE = 'SET_PAGE_CONTACT';
export const CHANGE_PAGE = 'CHANGE_PAGE_CONTACT';
export const CHANGE_STATUS= 'CHANGE_STATE_CONTACT';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_CONTACT';
export const CREATE_DATA = 'CREATE_CONTACT';
export const UPDATE_DATA = 'UPDATE_CONTACT';
export const DELETE_ITEM = 'DELETE_CONTACT';

export function actionFetchContact(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetContact({ index, row: sorting.row, order: sorting.order, ...filter });
    
console.log("Contact request data", request )
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionFetchCustomer(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetCustomer({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionCreateContact(data) {
    const request = serviceCreateContact(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved', type: 'success'});
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionCreateCustomer(data) {
    const request = serviceCreateCustomer(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved', type: 'success'});
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}
export function actionCreateQuery(data) {
    const request = serviceCreateQuery(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved', type: 'success'});
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionUpdateContact(data) {
    const request = serviceUpdateContact(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: UPDATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionDeleteContact(id) {
    const request = serviceDeleteContact({ id: id});
    return (dispatch) => {
        dispatch({type: DELETE_ITEM, payload: id})
    }
}


export function actionChangePageContactRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterContactRequests(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});//dispatch function
        });
    };
}


export function actionChangeStatusContactRequests(id, status) {
    // const request = serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterContactRequests() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageContactRequests(page,  extraPayload = {}) {
    const stateData = store.getState().contact;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchContact(serverPage + 1, sortingData, {query, query_data: queryData,  ...extraPayload}));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}

export function actionSetPageCustomerRequests(page) {
    const stateData = store.getState().contact;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchCustomer(serverPage + 1, sortingData, {query, query_data: queryData}));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}
